import { api } from '../../';
import { EstablishmentsData } from './types';

export const establishmentsApi = api.enhanceEndpoints({ addTagTypes: ['Establishments'] }).injectEndpoints({
  endpoints: build => ({
    getEstablishmentsList: build.query<EstablishmentsData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/establishments?${queryString}`,
        method: 'GET',
      }),
    }),
    getEstablishmentsSimpleList: build.query<EstablishmentsData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/establishments/simple-list?${queryString}`,
        method: 'GET',
      }),
    }),
    createEstablishments: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/establishments`,
        method: 'POST',
        body,
      }),
    }),
    updateEstablishments: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/establishments/${body.id}`,
        method: 'PATCH',
        body: body.data,
      }),
    }),
  }),
});

export const { useLazyGetEstablishmentsListQuery, useLazyGetEstablishmentsSimpleListQuery, useCreateEstablishmentsMutation, useUpdateEstablishmentsMutation } = establishmentsApi;
